import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { UserState } from '@core/state/user.state';
import { DecoratorInjectModule } from '@core/app/decorator-inject.module';
import { PrivilegesUsers } from '@core/privileges/privileges-users';
import { Observable } from 'rxjs';


export function HasPrivilege(modules: PrivilegesModules[], privilege?: PrivilegesUsers) {
    return function (target: any, key: string) {
        Object.defineProperty(target, key, {
            get: function (): Observable<boolean> {
                const userState: UserState = DecoratorInjectModule.injector?.get(UserState);

                return userState?.checkPrivilege(privilege ? privilege : PrivilegesUsers.Edit, modules[0]);
            },
            enumerable: true,
            configurable: true,
        });
    };
}
